import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env';
import { LanguageCode, ScriptLoaderService, SsrService } from '@interticket/core';
import { EMPTY } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ConfigService } from '../config/config.service';
import { StoreService } from '../store/store.service';
import { ThemeService } from '../theme/theme.service';

export function appInitializerFactory(appInitializer: AppInitializerService): () => Promise<any> {
  return (): Promise<any> => appInitializer.load();
}

@Injectable({
  providedIn: 'root',
})
export class AppInitializerService {

  constructor(
    protected themeService: ThemeService,
    protected authService: AuthService,
    protected storeService: StoreService,
    protected configService: ConfigService,
    protected scriptLoaderService: ScriptLoaderService,
    protected router: Router,
    protected ssrService: SsrService
  ) { }

  async load(): Promise<any> {
    return this.authService.load()
      .pipe(
        switchMap(() => this.themeService.initTheme()),
        tap(() => {
          this.scriptLoaderService.load(this.configService.siteConfig.scriptLoaderConfig);
          this.loadCrisp();
          this.storeService.appInitialized = true;
        }),
        catchError((e) => {
          console.error(e);
          this.router.navigate(['error', 'server-error']);

          return EMPTY;
        })
      )
      .toPromise();
  }

  private loadCrisp(): void {
    const defaultLanguageCode = this.storeService.partnerConfig.general.defaultLanguageCode;

    if (defaultLanguageCode === LanguageCode.EN || defaultLanguageCode === LanguageCode.HU) {
      this.scriptLoaderService.load({ ...!!environment.crisp && { crisp: environment.crisp } });
    }
  }

}
